import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getSettings, updateSettings } from "../api/client";
import type { SettingsUpdateRequest } from "../api/types";
import { queryKeys } from "./queryKeys";

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings(),
    queryFn: getSettings,
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: SettingsUpdateRequest) => updateSettings(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.settings(), data);
    },
  });
}
